import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { FormProvider, useForm } from "react-hook-form";
import { Box } from "@mui/material";

export const HubHookFormWrapper = ({
  children,
  onSubmit,
  defaultValues,
  sx = {},
  ref = null,
  isSuccess,
  useReset = true,
}) => {
  const form = useForm({
    defaultValues,
    shouldUnregister: false,
  });

  const { reset, formState } = form;
  const { dirtyFields } = formState;
  const prevDefaults = useRef(JSON.stringify(defaultValues));
  const justSubmitted = useRef(false);

  // Reset form when defaultValues change (e.g. switching objects or fresh API data)
  useEffect(() => {
    if (!defaultValues || !useReset) return;
    const serialized = JSON.stringify(defaultValues);
    if (serialized !== prevDefaults.current) {
      prevDefaults.current = serialized;
      if (justSubmitted.current) {
        // After a submit, the refetch updates defaults — sync baseline
        // without changing visible values so the form doesn't flicker
        reset(defaultValues, { keepValues: true });
        justSubmitted.current = false;
      } else {
        reset(defaultValues);
      }
    }
  }, [defaultValues, useReset, reset]);

  return (
    <FormProvider {...form}>
      <Box
        component="form"
        sx={{ width: "100%", ...sx }}
        onSubmit={(e) => {
          e.stopPropagation();
          return form.handleSubmit((data, event) => {
            justSubmitted.current = true;
            return onSubmit(data, event, dirtyFields);
          })(e);
        }}
        ref={ref}
      >
        {children}
      </Box>
    </FormProvider>
  );
};

HubHookFormWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default HubHookFormWrapper;
